export default __webpack_public_path__ + "b359e961c92c56828d3f7a7b43a98b7e.png";